import * as types from './mutation-types'
export default {
  [types.REALNAME_VERIFY_STATUS] (state, message) {
    state.verifyData = message || {}
  },
  [types.CELLID] (state, message) {
    state.cell_id = message
  },
  [types.ORDERS] (state, message) {
    state.orders = message
  },
  [types.ROLEID] (state, message) {
    state.roleId = message
  },
  [types.UNVERIFIED] (state, message) {
    state.unVerified = message
  },
  [types.ENV] (state, message) {
    state.env = message
  },
  [types.TICKET] (state, message) {
    state.ticket = message
  },
  [types.CELL] (state, message) {
    state.cell = message
  },
  [types.TRINITY_COLLECT_REASON] (state, payload) {
    state.trinity_collect_reason = payload
  },
  [types.AUTH_STATE] (state, payload) {
    state.authState = payload
  },
  [types.REALNAME_USER_INFO] (state, payload) {
    state.nameInfo = payload
  },
  [types.USER_HAS_REAL_NAME] (state, payload) {
    state.hasRealName = payload
  },
}
